import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	fetch: false,
};

const timezoneSlice = createSlice({
	name: "timezone_list",
	initialState,
	reducers: {
		get: (state) => {
			if (state.list.length === 0) {
				state.fetch = true;
			}
		},
		set: (state, action) => {
			if (state.list.length !== 0) return;
			state.list = action.payload;
			state.fetch = false;
		},
		drop: () => initialState,
	},
});

export const timezoneActions = timezoneSlice.actions;
export const timezoneReducer = timezoneSlice.reducer;
